import React from "react";
import Container from "./container";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";
import { cn } from "../lib/helpers";

import * as styles from "../styles/components/logos-section.module.css";

const LogosSection = (props) => {

  const {
    heading,
    logos
  } = props;

  return (
    <div className={styles.root}>
      <Container>
        {heading && <h2 className={cn("h6", styles.heading)}>{heading}</h2>}
        {(logos && logos.length) 
          ? <ul className={styles.logos}>
              {logos.map(logo => {
                return (
                  <li className={styles.item} key={logo._key}>
                    {logo && logo.asset && (
                      <img
                        src={imageUrlFor(buildImageObj(logo))
                          .auto("format")
                          .url()}
                        alt={logo.alt}
                      />
                    )}
                  </li>
                );
              })}
            </ul>
          : null
        }
      </Container>
    </div>
  );
}

export default LogosSection;
